export default __webpack_public_path__ + "static/media/planet_blue.914c6796.svg";